import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const links = [
  { id: "services", label: "Services" },
  { id: "why", label: "Why Us" },
  { id: "trust", label: "Authority" },
  { id: "inquiry", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goHome = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-nav" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-20 flex items-center justify-between">
        <button
          onClick={goHome}
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="/tbc-logo.jpeg"
            alt="The Bridge Collective"
            className="h-9 w-9 object-contain invert"
            style={{ filter: "invert(1) brightness(1.05) contrast(1.1)" }}
          />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-display tracking-[0.28em] text-white text-xs font-light">
              THE BRIDGE
            </span>
            <span className="font-display tracking-[0.28em] text-[#1A5C40] text-xs font-light">
              COLLECTIVE
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-xs uppercase tracking-[0.22em] text-zinc-400 hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            onClick={() => go("inquiry")}
            data-testid="nav-cta-inquire"
            className="btn-primary"
          >
            Email Our Team
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white p-2"
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden glass-nav border-t border-white/5"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`mobile-nav-link-${l.id}`}
                className="text-left text-sm uppercase tracking-[0.22em] text-zinc-300 hover:text-white"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("inquiry")}
              data-testid="mobile-nav-cta-inquire"
              className="btn-primary mt-2 self-start"
            >
              Email Our Team
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
